<div class="container px-4" *ngIf=" {appointments: myAppointments$ | async, authenticatedEmployee:
  authenticatedEmployee$ | async, authenticatedUser: authenticatedUser$ |async, loading:
  serviceLaneFacade.todaysAppointmentsLoading$ | async, digitalCheckInEnabled: digitalCheckInEnabled$ | async,
  unacknowledgedAppointments: serviceLaneFacade.unacknowledgedAppointmentCards$ | async,
  unacknowledgedAppointmentsStatus: serviceLaneFacade.unacknowledgedAppointmentsStatus$ | async,
  appointmentFilterDropdowns: serviceLaneDropdownFacade.serviceAppointmentDropdowns$ | async} as data;"
  style="background-color: #E5E7EB; margin-left: -16px; width: 820px">

  <!-- PL redesign - remove when completed START-->

  <!-- <ng-container *ngIf="data.unacknowledgedAppointmentsStatus === 'succeeded'">
  unacknowledgedAppointments: serviceLaneFacade.unacknowledgedAppointmentCards$| async, unacknowledgedAppointmentsStatus: serviceLaneFacade.unacknowledgedAppointmentsStatus$ | async } as data;">


  <!--XS-3029: new view appointments/digital check-in/work order lookup tabs-->
  <div style="width: 820px; height: 49px; margin-left: -16px;">
    <div style="width: 820px; height: 45px; background: #f5f5f5;"></div>
    <div style="width: 572px; height: 35px;">
      <div (click)="appointmentViewToggleTabs(0)"
        [ngStyle]="appointmentViewOpenTab === 0 ? {'border-bottom': 'solid', 'border-bottom-width': '2px', 'color': '#0054a6'} : {}"
        style="width: 192px; height:27px; position: absolute; left: 23px; top: 15px; font-size: 16px; text-align: center; border-bottom-color: #0054a6; color: #515251">
        View Appointments
      </div>
      <div (click)="appointmentViewToggleTabs(1)"
        [ngStyle]="appointmentViewOpenTab === 1 ? {'border-bottom': 'solid', 'border-bottom-width': '2px', 'color': '#0054a6'} : {}"
        style="width: 192px; height:27px; position: absolute; left: 224px; top: 15px; font-size: 16px; text-align: center; color: #515251; border-bottom-color: #0054a6;">
        Digital Check-in
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
          [ngStyle]="appointmentViewOpenTab === 1 ? {'bottom': '14px'} : {}"
          style="width: 18px; height: 18px; position: absolute; bottom:16px; left: 153px" preserveAspectRatio="none">
          <circle cx="9" cy="9" r="9" fill="#9747FF"></circle>
        </svg>
        <div [ngStyle]="appointmentViewOpenTab === 1 ? {'bottom': '22px'} : {}"
          style="width: 11px; height: 11px; position: absolute; left: 158.5px; bottom: 24px; font-size: 12px; font-weight: 600; text-align: left; color: #fff;">
          {{unacknowledgedAppointmentCount}}
        </div>
      </div>
      <div (click)="appointmentViewToggleTabs(2)"
        [ngStyle]="appointmentViewOpenTab === 2 ? {'border-bottom': 'solid', 'border-bottom-width': '2px', 'color': '#0054a6'} : {}"
        style="width: 192px; height:27px; position: absolute; left: 403px; top: 15px; font-size: 16px; text-align: center; color: #515251;">
        Work Order Lookup
      </div>
    </div>
  </div>

  <!-- <div style="width: 820px; height: 49px; margin-left: -14px;">
    <div style="width: 820px; height: 49px; background: #f5f5f5;"></div>
    <div style="width: 572px; height: 35px;">
      <svg width="192" height="2" viewBox="0 0 192 2" fill="none" xmlns="http://www.w3.org/2000/svg"
        style="position: absolute; left: 23px; top: 40px;" preserveAspectRatio="xMidYMid meet">
        <line x1="-8.74228e-8" y1="1" x2="192" y2="0.999983" stroke="#0054A6" stroke-width="2"></line>
      </svg>
      <p
        style="width: 192px; position: absolute; left: 23px; top: 15px; font-size: 16px; text-align: center; color: #0054a6;">
        View Appointments
      </p>
      <p
        style="width: 192px; position: absolute; left: 224px; top: 15px; font-size: 16px; text-align: center; color: #515251;">
        Work Order Lookup
      </p>
      <p
        style="width: 192px; position: absolute; left: 403px; top: 15px; font-size: 16px; text-align: center; color: #515251;">
        Digital Check-in
      </p>

  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
    style="width: 18px; height: 18px; position: absolute; top:8px; left: 554.5px" preserveAspectRatio="none">
    <circle cx="9" cy="9" r="9" fill="#9747FF"></circle>
  </svg>
  <p
    style="width: 11px; height: 11px; position: absolute; left: 560px; top: 7.5px; font-size: 12px; font-weight: 600; text-align: left; color: #fff;">
    {{data.unacknowledgedAppointments.length}}
  </p>
</div>
</div> -->

  <!--XS-3029: Old unacknowledged appts needs to be removed-->
  <!-- <ng-container *ngIf="data.unacknowledgedAppointmentsStatus === 'succeeded'">
    <div id="unacknowledgedAppointments" class="today-appointment-header"
      *ngIf="data.unacknowledgedAppointments.length > 0">
      <div class="search-result-card-container">
        <div class="font-normal sticky top-16 bg-white flex flex-row place-content-between place-items-center"
          (click)="unacknowledgedAppointmentsCollapse = !unacknowledgedAppointmentsCollapse">
          <div class="flex flex-row place-content-start place-items-center mb-4">
            <div
              style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
              fxLayoutAlign="space-between center">
              <h1 class="mr-3 mb-0">Unacknowledged Appointments</h1>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div
                  style="font-size:11px;border-radius:50%;background-color:#D32F2F;color:#FFF;padding:0 6px;font-weight:500;margin-right:4px;">
                  {{getCheckedInCount(data.unacknowledgedAppointments)}}
                </div>
              </div>
            </div>
          </div>
          <button class="mb-4" mat-icon-button>
            <mat-icon>
              {{unacknowledgedAppointmentsCollapse? 'keyboard_arrow_up' :'keyboard_arrow_down'}}
            </mat-icon>
          </button>
        </div>
        <div *ngIf="unacknowledgedAppointmentsCollapse">
          <div *ngFor="let item of data.unacknowledgedAppointments | orderBy: 'time';trackBy: trackByFunction"
            class="result-container">
            <div class="result-container-header flex place-content-between place-items-start">
              <div class="result-container-header-text">
                <div class="flex flex-row place-content-start place-items-center">
                  <div class="flex place-content-center place-items-center type-container">
                    <span>A</span>
                  </div>
                  <h3 class="flex flex-row place-content-start place-items-center" id="customer-name-link"
                    *ngIf="item.customer; else freeformCustomer">
                    <a *ngIf="item.vehicle; else freeformAppointment" class="fake-anchor"
                      (click)="navigateToAppointment(item, data.digitalCheckInEnabled, data.authenticatedUser)">
                      {{[item?.customer?.lastName, item?.customer?.firstName] | nameSafety}}
                    </a>
                    <ng-template #freeformAppointment>
                      <span>{{[item?.customerName] | nameSafety}} - </span>
                      <a [routerLink]="'/freeform-appointment/' + item.id" class="pl-1 fake-anchor"
                        [queryParams]="{search: item.customerName, phoneNumber: item.phoneNumber}">match</a>
                    </ng-template>
                  </h3>
                  <ng-template #freeformCustomer>
                    <h3>
                      <span>{{[item?.customerName] | nameSafety}} - </span>
                      <a [routerLink]="'/freeform-appointment/' + item.id"
                        [queryParams]="{search: item.customerName, phoneNumber: item.phoneNumber}"
                        class="fake-anchor">match</a>
                    </h3>
                  </ng-template>
                </div>
                <div class="flex place-items-center">
                  <mat-icon class="text-base h-4 ml-0.5">schedule</mat-icon>
                  <span id="service-advisor-info-span" class="font-medium">{{ item.time | date :'medium'}}
                    <i *ngIf="item?.serviceAdvisor; else noAdvisor">
                      with {{item.serviceAdvisor.firstName ? item.serviceAdvisor.firstName : ''}}
                      {{item.serviceAdvisor.lastName ? item.serviceAdvisor.lastName : ''}}</i>
                    <ng-template #noAdvisor>
                      <i>No advisor selected</i>
                    </ng-template>
                  </span>
                </div>

                <div class="flex place-content-start place-items-center font-medium">
                  <mat-icon class="text-base h-4 my-0 mr-0 ml-0.5">directions_car</mat-icon>
                  <span id="vehicle-info-span" *ngIf="item.vehicle; else freeformVehicle">
                    {{item?.vehicle?.year + ' ' + item?.vehicle?.make + ' ' + item?.vehicle?.model}}</span>
                </div>

                <ng-template #freeformVehicle>{{item?.vehicleDescription}}</ng-template>


              </div>

              <div class="result-container-header-actions">
                <button id="delete-button" mat-icon-button (click)="deleteTodaysAppointment(item, $event)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="result-container-content">
              <div class="result-container-content-line">
                <span class="primary-bullet">·</span>
                <span id="service-code-info-span">The service code is {{item.serviceCode}}</span>
              </div>
              <div class="result-container-content-line">
                <span class="primary-bullet">·</span>
                <span id="ride-preference-info-span"
                  [ngClass]="{ 'cadillac-concierge': item.ridePreference == 'Cadillac Premium Concierge' }">Ride
                  preference is
                  {{item.ridePreference ? item.ridePreference : 'not indicated.' }}</span>
              </div>
              <div class="result-container-content-line">
                <span class="primary-bullet">·</span>
                <span id="booked-by-info-span">Appointment booked by
                  {{item.vendorName ? item.vendorName : 'the dealership.' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container> -->

  <!--XS-3029: Old work order lookup  needs to be removed-->
  <!-- Replaced by PL redesign buttons-->
  <!-- <div class="sticky flex place-content-between place-items-center today-appointment-header">

    <div class="flex flex-row space-x-2">
      <h1 class="m-0">Appointments</h1>
      <h1 class="font-light" *ngIf="(dateFrom | date: 'MMMM d') != (dateTo | date: 'MMMM d')">
        ({{dateFrom | date :'MMMM d'}} - {{ dateTo | date :'MMMM d'}})
      </h1>
    </div>
    <div>
      <a mat-button [routerLink]="'/tech'">Work Order Lookup</a>
      <button id="refresh-button" mat-icon-button color="primary" (click)="refreshAppointments()">
        <mat-icon>refresh</mat-icon>
      </button>

      <button id="expand-filters-button" mat-icon-button cdkOverlayOrigin #trigger="cdkOverlayOrigin"
        (click)="isPopoverOpen = !isPopoverOpen" class="filter-button">
        <mat-icon>filter_list</mat-icon>
      </button>
      <ng-template cdkConnectedOverlay cdkConnectedOverlayPanelClass="overlay-container"
        cdkConnectedOverlayBackdropClass="none" [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayOpen]="isPopoverOpen" [cdkConnectedOverlayOrigin]="trigger"
        (backdropClick)="isPopoverOpen = false">
        <svc-appointments-list-filter class="bg-white"
          [appointmentFilterDropdowns$]="serviceLaneDropdownFacade.serviceAppointmentDropdowns$"
          (filtersChanged)="applyAppointmentFilters($event, data.authenticatedEmployee); isPopoverOpen = false">
        </svc-appointments-list-filter>
      </ng-template>
    </div>
  </div> -->
  <!-- End replaced by PL redesign buttons -->


  <!-- Start - New Date Filtering XS-3025, enabled when the epic is done-->
  <div style="height: 40px;" class="flex flex-row px-2 place-content-between mb-7 mt-10">
    <div class="flex flex-row">
      <div style="width: 115px; height: 40px;  border-radius: 4px;"
        [ngStyle]="{'background': dateFilterOpenTab === 0 ? '#0054a6': '#fff'}"
        class="flex place-content-center items-end"
        (click)="dateFilterToggleTabs(0); applyAppointmentFilters(todayFilter, data.authenticatedEmployee);">
        <p style="width: 64px;  font-size: 16px; text-align: center; line-height: 16px;"
          [ngStyle]="{'color': dateFilterOpenTab === 0 ? '#fff': '#515251'}">
          Today
        </p>
      </div>
      <div style="width: 115px; height: 40px; border-radius: 4px;"
        [ngStyle]="{'background': dateFilterOpenTab === 1 ? '#0054a6': '#fff'}"
        (click)="dateFilterToggleTabs(1); applyAppointmentFilters(tomorrowFilter, data.authenticatedEmployee);"
        class="flex place-content-center items-end">

        <p style="width: 106px; font-size: 16px; text-align: center; line-height: 16px;"
          [ngStyle]="{'color': dateFilterOpenTab === 1 ? '#fff': '#515251'}">
          Tomorrow
        </p>
      </div>
      <div style="width: 115px; height: 40px; border-radius: 4px;"
        [ngStyle]="{'background': dateFilterOpenTab === 2 ? '#0054a6': '#fff'}" (click)="dateFilterToggleTabs(2)"
        class="flex place-content-center items-end" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
        (click)="isPopoverOpen = !isPopoverOpen">

        <p style="width: 80px;  font-size: 16px; text-align: center; line-height: 16px;"
          [ngStyle]="{'color': dateFilterOpenTab === 2 ? '#fff': '#515251'}">
          Custom
        </p>
      </div>
      <ng-template cdkConnectedOverlay cdkConnectedOverlayPanelClass="overlay-container"
        cdkConnectedOverlayBackdropClass="none" [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayOpen]="isPopoverOpen" [cdkConnectedOverlayOrigin]="trigger"
        (backdropClick)="isPopoverOpen = false">
        <svc-appointments-list-filter class="bg-white"
          [appointmentFilterDropdowns$]="serviceLaneDropdownFacade.serviceAppointmentDropdowns$"
          (filtersChanged)="applyAppointmentFilters($event, data.authenticatedEmployee); isPopoverOpen = false">
        </svc-appointments-list-filter>
      </ng-template>
    </div>

    <div class="flex flex-row space-x-4">
      <div class="flex justify-center relative text-left">
        <button (click)="resetFilters(data.authenticatedEmployee)">
          <mat-icon color="primary">refresh</mat-icon>
        </button>
      </div>

      <div class="relative inline-block text-left">

        <div (click)="toggleRidePreferenceDropdown()" (shaClickOutside)="clickedOutsideRidePreference()"
          style="width: 170px;font-family: 'Open Sans'; font-style:normal;font-weight:400;font-size:16px; line-height: 22px; color: #515251;  border-radius: 4px; border: 1px solid #0054A6; padding: 7px 0px"
          class="inline-flex justify-center bg-white px-3 text-gray-900 shadow-sm" id="menu-button" aria-expanded="true"
          aria-haspopup="true" id="ride-preference-dropdown">
          {{selectedRidePreference}}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15L7 10H17L12 15Z" fill="#1C1C1C" />
          </svg>
        </div>


        <div *ngIf="showRidePreferences"
          class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1"
          id="ride-preference-dropdown-menu">
          <div class="py-1" role="none">
            <span class="text-gray-700 block px-4 py-2 text-sm"
              style="font-family: 'Open Sans'; font-style:normal;font-weight:400;font-size:16px; line-height: 22px; color: #515251;"
              role="menuitem" tabindex="-1" id="ride-pref-option-none"
              (click)="applyRidePreferenceFilter(null, data.authenticatedEmployee);">
              None</span>
            <span
              *ngFor="let transportOption of data.appointmentFilterDropdowns?.transportOptions | orderBy:['name']; let i = index"
              class="text-gray-700 block px-4 py-2 text-sm"
              style="font-family: 'Open Sans'; font-style:normal;font-weight:400;font-size:16px; line-height: 22px; color: #515251;"
              role="menuitem" tabindex="-1" id="{{ 'ride-pref-option-' + i }}"
              (click)="applyRidePreferenceFilter(transportOption, data.authenticatedEmployee);">
              {{transportOption.name}}</span>
          </div>
        </div>
      </div>

      <div class=" relative inline-block text-left">

        <div (click)="toggleServiceCodeDropdown()" (shaClickOutside)="clickedOutsideServiceCode()"
          style="width: 170px; font-family: 'Open Sans'; font-style:normal;font-weight:400;font-size:16px; line-height: 22px; color: #515251;  border-radius: 4px; border: 1px solid #0054A6;padding: 7px 0px "
          class="inline-flex justify-center bg-white px-3 text-gray-900 shadow-sm" id="menu-button" aria-expanded="true"
          aria-haspopup="true">
          {{selectedServiceCode}}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15L7 10H17L12 15Z" fill="#1C1C1C" />
          </svg>
        </div>


        <div *ngIf="showServiceCodes"
          class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
          <div class="py-1" role="none" class="service-codes-container">
            <span class="text-gray-700 block px-4 py-2 text-sm"
              style="font-family: 'Open Sans'; font-style:normal;font-weight:400;font-size:16px; line-height: 22px; color: #515251"
              role="menuitem" tabindex="-1" id="menu-item-{{i}}"
              (click)="applyServiceCodeFilter(null, data.authenticatedEmployee);">
              None</span>
            <span
              *ngFor="let serviceCode of data.appointmentFilterDropdowns.serviceCodes | orderBy:['-favourite', 'serviceCode']; let i = index"
              class="text-gray-700 block px-4 py-2 text-sm"
              [ngClass]="{'service-code-divider': i === 0, 'service-code-item' : serviceCode.favourite === false}"
              style="font-family: 'Open Sans'; font-style:normal;font-weight:400;font-size:16px; line-height: 22px; color: #515251;"
              role="menuitem" tabindex="-1" id="menu-item-{{i}}"
              (click)="applyServiceCodeFilter(serviceCode, data.authenticatedEmployee);">
              {{serviceCode.serviceCode}} - {{serviceCode.description}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End - New Date Filtering XS-3025, enabled when the epic is done -->

  <ng-container *ngIf="data.loading; else loadingComplete">
    <div id="loading-div" class="search-results-container">
      <div class="search-result-card-container">
        <span mat-subheader class="flex flex-row place-content-between place-items-center">
          <span class="animated-background h-8 w-1/2 mt-1.5 mb-4 rounded"></span>
        </span>
        <div class="animated-background my-4" style="width: 772px; height: 226px; border-radius: 5px;">
        </div>
        <div class="animated-background my-4" style="width: 772px; height: 226px; border-radius: 5px;">
        </div>
        <div class="animated-background my-4" style="width: 772px; height: 226px; border-radius: 5px;">
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loadingComplete>
    <div class="search-results-container" *ngIf="appointmentViewOpenTab === 0 ">
      <div id="loading-complete" *ngIf="(groupedAppointments | keyvalue)?.length > 0 ; else noAppointments"
        class="search-result-card-container">
        <div *ngFor="let appointmentGroup of groupedAppointments | pairs;let i = index;">
          <div class="font-normal sticky top-1 flex flex-row space-x-3 place-items-center py-3"
            style="background-color: #E5E7EB" style="z-index: 1">
            <ng-container [ngSwitch]="appointmentGroup[1][0].time | date: 'fullDate'">
              <div class="flex flex-row place-content-start place-items-center"
                style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 22px; line-height: 30px; color: #1C1C1C;">

                <div class="flex flex-row" fxLayoutAlign="start center" *ngSwitchCase="(today | date: 'fullDate')">
                  <span class="font-normal mr-3 mb-0">Today</span>

                  <!-- <div *ngIf="getCheckedInCount(appointmentGroup[1]) > 0" fxLayout="row">
                    <div
                      style="font-size:11px;border-radius:50%;background-color:#D32F2F;color:#FFF;padding:0 6px;font-weight:500;margin-right:4px;">
                      {{getCheckedInCount(appointmentGroup[1])}}
                    </div>
                    <span class="text-red"> Appointments awaiting
                      acknowledgement</span>
                  </div> -->
                </div>
                <span class="font-normal" *ngSwitchCase="(yesterday | date: 'fullDate')">Yesterday
                  <!-- <span
                    class="text-red"
                    *ngIf="getCheckedInCount(appointmentGroup[1]) > 0">({{getCheckedInCount(appointmentGroup[1])}}
                    checked
                    in appointments awaiting acknowledgement)</span> -->
                </span>
                <span class="font-normal" *ngSwitchCase="(tomorrow | date: 'fullDate')">Tomorrow
                  <!-- <span class="text-red"
                    *ngIf="getCheckedInCount(appointmentGroup[1]) > 0">({{getCheckedInCount(appointmentGroup[1])}}
                    checked
                    in appointments awaiting acknowledgement)</span> -->
                </span>
                <div class="flex flex-row" fxLayoutAlign="start center" *ngSwitchCase="(yesterday | date: 'fullDate')">
                  <h2 class="font-normal"></h2>

                  <!-- <div *ngIf="getCheckedInCount(appointmentGroup[1]) > 0" class="flex flex-row">
                    <div
                      style="font-size:11px;border-radius:50%;background-color:#D32F2F;color:#FFF;padding:0 6px;font-weight:500;margin-right:4px;">
                      {{getCheckedInCount(appointmentGroup[1])}}
                    </div>
                    <span class="text-red"> Appointments awaiting
                      acknowledgement</span>
                  </div> -->
                </div>
                <div class="flex flex-row" fxLayoutAlign="start center" *ngSwitchCase="(tomorrow | date: 'fullDate')">
                  <h2 class="font-normal"></h2>

                  <!-- <div *ngIf="getCheckedInCount(appointmentGroup[1]) > 0" fxLayout="row">
                    <div
                      style="font-size:11px;border-radius:50%;background-color:#D32F2F;color:#FFF;padding:0 6px;font-weight:500;margin-right:4px;">
                      {{getCheckedInCount(appointmentGroup[1])}}
                    </div>
                    <span class="text-red"> Appointments awaiting
                      acknowledgement</span>
                  </div> -->
                </div>

                <span class="font-normal" *ngSwitchDefault>
                  {{appointmentGroup[1][0].time | date: 'fullDate'}}
                </span>
              </div>
            </ng-container>
            <span
              style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 22px; line-height: 30px; color: #0054A6;">
              ({{appointmentGroup[1].length}} {{appointmentGroup[1].length === 1 ? 'appointment' : 'appointments'}})
            </span>
          </div>

          <!-- New "CARD" div, XS-3024 task to be enabled when the others are done-->
          <div class="flex flex-col">
            <quorum-appointment-card style="width: 772px; height: 226px;" class="my-4"
              *ngFor="let item of appointmentGroup[1] | orderBy: 'time';trackBy: trackByFunction"
              [appointmentData]="item" [vehicleDropdowns$]="serviceLaneDropdownFacade.vehicleDropdowns$"
              (checkIn)="navigateToAppointment(item, data.digitalCheckInEnabled, data.authenticatedUser)"></quorum-appointment-card>
          </div>

          <!-- OLD "CARD" DIV START-->
          <!-- <div *ngFor="let item of appointmentGroup[1] | orderBy: 'time';trackBy: trackByFunction"
            class="result-container">
            <div class="result-container-header flex place-content-between place-items-start">
              <div class="result-container-header-text">
                <div class="flex flex-row place-content-start place-items-center"
                  *ngIf="item.type === 'appointment'; else workOrder">
                  <div class="flex place-content-center place-items-center type-container">
                    <span>A</span>
                  </div>
                  <h3 class="flex flex-row place-content-start place-items-center" id="customer-name-link"
                    *ngIf="item.customer; else freeformCustomer">
                    <a *ngIf="item.vehicle; else freeformAppointment" class="fake-anchor"
                      (click)="navigateToAppointment(item, data.digitalCheckInEnabled, data.authenticatedUser)">
                      {{[item?.customer?.lastName, item?.customer?.firstName] | nameSafety}}
                    </a>
                    <div class="flex flex-row place-content-center place-items-center"
                      *ngIf="item.digitalCheckInStatus == 'CHECKED_IN'"
                      style="margin-left:10px;border-radius:24px;background-color:#C62828;padding:0 8px;height:20px;">
                      <span style="color:#FFF;font-size:11px;">Awaiting Acknowledgement</span>
                    </div>

                    <ng-template #freeformAppointment>
                      <span>{{[item?.customerName] | nameSafety}} - </span>
                      <a [routerLink]="'/freeform-appointment/' + item.id" class="pl-1 fake-anchor"
                        [queryParams]="{search: item.customerName, phoneNumber: item.phoneNumber}">match</a>
                      <div class="flex flex-row place-content-center place-items-center"
                        *ngIf="item.digitalCheckInStatus == 'CHECKED_IN'"
                        style="margin-left:10px;border-radius:24px;background-color:#C62828;padding:0 8px;height:20px;">
                        <span style="color:#FFF;font-size:11px;">Awaiting Acknowledgement</span>
                      </div>
                    </ng-template>
                  </h3>
                  <ng-template #freeformCustomer>
                    <h3>
                      <span>{{[item?.customerName] | nameSafety}} - </span>
                      <a [routerLink]="'/freeform-appointment/' + item.id"
                        [queryParams]="{search: item.customerName, phoneNumber: item.phoneNumber}"
                        class="fake-anchor">match</a>
                    </h3>
                  </ng-template>
                </div>
                <ng-template #workOrder>
                  <div class="flex place-content-start place-items-center">
                    <div class="flex place-content-center place-items-center type-container">
                      <span>W</span>
                    </div>
                    <h3>{{[item?.customer?.lastName, item?.customer?.firstName] | nameSafety}}</h3>
                  </div>
                </ng-template>
                <div class="flex place-items-center">
                  <mat-icon class="text-base h-4 ml-0.5">schedule</mat-icon>
                  <span id="service-advisor-info-span" class="font-medium">{{ item.time | date: 'shortTime'}}
                    <i *ngIf="item?.serviceAdvisor; else noAdvisor">
                      with {{item.serviceAdvisor.firstName ? item.serviceAdvisor.firstName : ''}}
                      {{item.serviceAdvisor.lastName ? item.serviceAdvisor.lastName : ''}}</i>
                    <ng-template #noAdvisor>
                      <i>No advisor selected</i>
                    </ng-template>
                  </span>
                </div>

                <div class="flex place-content-start place-items-center font-medium">
                  <mat-icon class="text-base h-4 my-0 mr-0 ml-0.5">directions_car</mat-icon>
                  <span id="vehicle-info-span" *ngIf="item.vehicle; else freeformVehicle">
                    {{item?.vehicle?.year + ' ' + item?.vehicle?.make + ' ' + item?.vehicle?.model}}</span>
                </div>

                <ng-template #freeformVehicle>{{item.vehicleDescription}}</ng-template>


              </div>

              <div class="result-container-header-actions">
                <button id="delete-button" *ngIf="item.type === 'appointment'" mat-icon-button
                  (click)="deleteTodaysAppointment(item, $event)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="result-container-content">
              <div class="result-container-content-line" *ngIf="item.type == 'workOrder'">
                <span class="primary-bullet">·</span>
                <span id="work-order-number-span">The work order # is
                  {{item.id ? item.id : 'not available.' }}</span>
              </div>
              <div class="result-container-content-line">
                <span class="primary-bullet">·</span>
                <span id="service-code-info-span">The service code is {{item.serviceCode}}</span>
              </div>
              <div class="result-container-content-line">
                <span class="primary-bullet">·</span>
                <span id="ride-preference-info-span"
                  [ngClass]="{ 'cadillac-concierge': item.ridePreference == 'Cadillac Premium Concierge' }">Ride
                  preference is
                  {{item.ridePreference ? item.ridePreference : 'not indicated.' }}</span>
              </div>
              <div class="result-container-content-line">
                <span class="primary-bullet">·</span>
                <span id="booked-by-info-span">Appointment booked by
                  {{item.vendorName ? item.vendorName : 'the dealership.' }}</span>
              </div>
            </div>
          </div> -->
          <!-- OLD "CARD" DIV START-->
        </div>
      </div>
    </div>

    <!--XS-3029: new div for the new tabs-->
    <div class="search-results-container" *ngIf="appointmentViewOpenTab === 1 ">
      <div id="loading-complete"
        *ngIf="(groupedUnacknowledgedAppointments | keyvalue)?.length > 0 ; else noAppointments"
        class="search-result-card-container">
        <div *ngFor="let appointmentGroup of groupedUnacknowledgedAppointments | pairs;let i = index;">
          <div class="font-normal sticky top-1 flex flex-row space-x-3 place-items-center py-3"
            style="background-color: #E5E7EB" style="z-index: 1">
            <ng-container [ngSwitch]="appointmentGroup[1][0].time | date: 'fullDate'">
              <div class="flex flex-row place-content-start place-items-center"
                style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 22px; line-height: 30px; color: #1C1C1C;">

                <div class="flex flex-row" fxLayoutAlign="start center" *ngSwitchCase="(today | date: 'fullDate')">
                  <span class="font-normal mr-3 mb-0">Today</span>

                  <!-- <div *ngIf="getCheckedInCount(appointmentGroup[1]) > 0" fxLayout="row">
                    <div
                      style="font-size:11px;border-radius:50%;background-color:#D32F2F;color:#FFF;padding:0 6px;font-weight:500;margin-right:4px;">
                      {{getCheckedInCount(appointmentGroup[1])}}
                    </div>
                    <span class="text-red"> Appointments awaiting
                      acknowledgement</span>
                  </div> -->
                </div>
                <span class="font-normal" *ngSwitchCase="(yesterday | date: 'fullDate')">Yesterday
                  <!-- <span
                    class="text-red"
                    *ngIf="getCheckedInCount(appointmentGroup[1]) > 0">({{getCheckedInCount(appointmentGroup[1])}}
                    checked
                    in appointments awaiting acknowledgement)</span> -->
                </span>
                <span class="font-normal" *ngSwitchCase="(tomorrow | date: 'fullDate')">Tomorrow
                  <!-- <span class="text-red"
                    *ngIf="getCheckedInCount(appointmentGroup[1]) > 0">({{getCheckedInCount(appointmentGroup[1])}}
                    checked
                    in appointments awaiting acknowledgement)</span> -->
                </span>
                <div class="flex flex-row" fxLayoutAlign="start center" *ngSwitchCase="(yesterday | date: 'fullDate')">
                  <h2 class="font-normal"></h2>

                  <!-- <div *ngIf="getCheckedInCount(appointmentGroup[1]) > 0" class="flex flex-row">
                    <div
                      style="font-size:11px;border-radius:50%;background-color:#D32F2F;color:#FFF;padding:0 6px;font-weight:500;margin-right:4px;">
                      {{getCheckedInCount(appointmentGroup[1])}}
                    </div>
                    <span class="text-red"> Appointments awaiting
                      acknowledgement</span>
                  </div> -->
                </div>
                <div class="flex flex-row" fxLayoutAlign="start center" *ngSwitchCase="(tomorrow | date: 'fullDate')">
                  <h2 class="font-normal"></h2>

                  <!-- <div *ngIf="getCheckedInCount(appointmentGroup[1]) > 0" fxLayout="row">
                    <div
                      style="font-size:11px;border-radius:50%;background-color:#D32F2F;color:#FFF;padding:0 6px;font-weight:500;margin-right:4px;">
                      {{getCheckedInCount(appointmentGroup[1])}}
                    </div>
                    <span class="text-red"> Appointments awaiting
                      acknowledgement</span>
                  </div> -->
                </div>

                <span class="font-normal" *ngSwitchDefault>
                  {{appointmentGroup[1][0].time | date: 'fullDate'}}
                </span>
              </div>
            </ng-container>
            <span
              style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 22px; line-height: 30px; color: #0054A6;">
              ({{appointmentGroup[1].length}} {{appointmentGroup[1].length === 1 ? 'appointment' : 'appointments'}})
            </span>
          </div>


          <div class="flex flex-col">
            <quorum-appointment-card style="width: 772px; height: 226px;" class="my-4"
              *ngFor="let item of appointmentGroup[1] | orderBy: 'time';trackBy: trackByFunction"
              [appointmentData]="item" [vehicleDropdowns$]="serviceLaneDropdownFacade.vehicleDropdowns$"
              (checkIn)="navigateToAppointment(item, data.digitalCheckInEnabled, data.authenticatedUser)"></quorum-appointment-card>
          </div>
        </div>
      </div>
    </div>

    <!--XS-3029: new div for the new tabs-->
    <div class="search-results-container" *ngIf="appointmentViewOpenTab === 2 ">
      <svc-tech-landing></svc-tech-landing>
    </div>

    <ng-template #noAppointments>
      <div id="no-appointments" class="flex flex-col place-items-center search-results-container mt-14"
        style="height: 840px">
        <mat-icon class="h-24 w-24" color="no-results-icon" [svgIcon]="noResultsDisplayIcon"></mat-icon>
        <span class="mat-body-2">No appointments found {{noResultsDateDisplay}}.</span>
      </div>
    </ng-template>
  </ng-template>
</div>